/** Bump after vendor profile fields change so hub nav and hooks refetch. */
const listeners = new Set<() => void>();

export function subscribeVendorProfileRefresh(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function notifyVendorProfileChanged(): void {
  for (const listener of listeners) listener();
}
